import React from "react";
import Chip from "@material-ui/core/Chip";
import { Option } from "./utils";
import { makeStyles } from "@material-ui/core/styles";

type Props = {
  disabled?: boolean;
  id: string;
  instancePrefix: string;
  label?: string;
  onClick: (value: string | Option) => any;
  onRemove?: (value: string | Option) => any;
  placeholder: string;
  value: string | Option;
  skipChipDeleteIcon?: boolean;
};

export function SelectValueChip(props: Props) {
  const classes = useStyles({});

  return (
    <Chip
      classes={classes}
      label={props.label}
      onDelete={props.skipChipDeleteIcon === true ? null : props.onRemove}
      tabIndex={-1}
      variant="outlined"
      icon={typeof props.value === "object" ? props.value.icon : null}
    />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 24,
    height: "auto",

    "&:not(:last-child)": {
      marginRight: theme.spacing(1 / 2)
    }
  },

  label: {
    padding: 4
  },

  deleteIcon: {
    height: 16,
    marginLeft: 0
  }
}));
